import {
  RIVERSECTIONMANAGE
} from '../actions/riverSectionManage';
import { reducerPackage } from "../../utils";

export const riverSectionManageList = reducerPackage(RIVERSECTIONMANAGE);

